import script from "./ds-top-subheadline.vue?vue&type=script&lang=ts&setup=true"
export * from "./ds-top-subheadline.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__